const en_supplychain_distributionPoint = {
    "": "supply chain",
    add: "add distribution point",
    edit: "edit distribution point",

    label: {
        name: "Distribution Point Name",
        to_whs: "to warehouse",
    },

    error: {
        create: "Failed to create distribution point",
        edit: "Failed to update distribution point",
        name: "Distribution point name is required",
    },

    success: {
        create: "Distribution point created successfully",
        edit: "Distribution point updated successfully",
    },
}

export default en_supplychain_distributionPoint;